import React, { useEffect, useState } from 'react';
import { ServicesHero } from '../components/services/ServicesHero.tsx';
import { ServiceCards } from '../components/services/ServiceCards.tsx';
import { ProcessFlow } from '../components/services/ProcessFlow.tsx';
import { ServicesCTA } from '../components/services/ServicesCTA.tsx';
import {Footer} from '../components/contact/Footer.tsx';

export function ServicesPage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`services-page ${isLoaded ? 'loaded' : ''}`} style={{ paddingTop: '80px' }}>
      <ServicesHero />
      <ServiceCards />
      <ProcessFlow />
      <ServicesCTA />
      <Footer />
    </div>
  );
}
